import { Spin, Table } from 'antd';

import type { ModelProductBrand } from '@app/api/Products';
import { useWindowSize } from '@app/hooks';
import { PF } from '@app/pages/Warehouses/Brands/data';
import type { BrandsTableType } from '@app/pages/Warehouses/Brands/types';

const TABLE = `${PF}_table`;

export const BrandsTable: BrandsTableType = ({
  columns,
  data,
  total,
  filters: { Page, ItemsPerPage },
  range: { from, to },
  onPageSizeChange,
  onPaginate,
  isPageLoading = false,
  isFetching = false,
}) => {
  const { isMobile } = useWindowSize();

  if (isPageLoading) {
    return (
      <div className={`${TABLE}_loading`}>
        <Spin spinning />
      </div>
    );
  }

  return (
    <div className={`${TABLE}_container`}>
      <div className={`${TABLE}_content`}>
        <Table<ModelProductBrand>
          columns={columns}
          dataSource={data}
          rowKey={({ Id }) => Id}
          pagination={
            total > 0
              ? {
                  responsive: true,
                  current: Page,
                  total,
                  pageSize: ItemsPerPage,
                  showSizeChanger: true,
                  showLessItems: isMobile,
                  size: isMobile ? 'small' : 'default',
                  position: isMobile ? ['bottomCenter'] : ['bottomLeft'],
                  onChange: onPaginate,
                  onShowSizeChange: (_, pageSize) => onPageSizeChange(pageSize),
                  showTotal: (itemsTotal) =>
                    isMobile
                      ? `Всего ${itemsTotal}`
                      : `Показаны результаты с ${from} по ${to} из ${itemsTotal}`,
                }
              : false
          }
          size={isMobile ? 'small' : 'middle'}
          loading={isFetching}
          scroll={{ x: 'max-content' }}
          className={`${TABLE}_grid`}
        />
      </div>
    </div>
  );
};
